import { type WidgetSettingsDefinition } from "@repo/api";

export const COMMON_SETTINGS: Record<string, WidgetSettingsDefinition> = {
  COWORKER: {
    id: "COWORKER",
    title: "label.coworker_filter",
    type: "coworker",
    required: false,
  },
  STORE: {
    id: "STORE",
    title: "label.store_filter",
    type: "store",
    required: false,
  },
};
